import React, { useState, useEffect } from 'react';
import { Box, Grid, ToggleButtonGroup, ToggleButton } from '@mui/material';

function DetailedSequencingQualitySummary(props) {
  const {
    analysis
  } = props;

  const [filteringView, setFilteringView] = useState('post');

  const hasValue = (value) => value != null;
  const formatPercent = (value) => (hasValue(value) ? (value * 100).toFixed(2) : '-');
  const formatReadLength = (megabases, reads) => {
    if (!hasValue(megabases) || !reads) return '-';

    return Math.round(megabases * 1000000 / reads).toLocaleString();
  };

  const preFilteringMetrics = {
    q20: analysis?.attributes?.pre_filtering_q20_rate,
    q30: analysis?.attributes?.pre_filtering_q30_rate,
    gc: analysis?.attributes?.pre_filtering_gc_content,
  };

  const postFilteringMetrics = {
    q20: analysis?.attributes?.q20_rate,
    q30: analysis?.attributes?.q30_rate,
    gc: analysis?.attributes?.gc_content,
  };

  const hasPreFilteringMetrics = Boolean(
    analysis &&
    hasValue(preFilteringMetrics.q20) &&
    hasValue(preFilteringMetrics.q30) &&
    hasValue(preFilteringMetrics.gc)
  );

  useEffect(() => {
    if (!hasPreFilteringMetrics && filteringView === 'pre') {
      setFilteringView('post');
    }
  }, [hasPreFilteringMetrics, filteringView]);

  const metrics = filteringView === 'pre' && hasPreFilteringMetrics
    ? preFilteringMetrics
    : postFilteringMetrics;

  return (
    <>
      <Box sx={{ backgroundColor: '#eee', padding: '1px 10px' }}>
        <Grid container>
          <Grid item xs={12}>
            <p><b>SEQUENCING DATA QUALITY</b></p>
          </Grid>
        </Grid>
      </Box>
      <Grid container>
        <Grid item xs={12}>
          <Box sx={{ padding: '15px 40px' }}>
            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 2, mb: 2, backgroundColor: '#fafafa' }}>
              {hasPreFilteringMetrics ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>
                  <ToggleButtonGroup
                    size="small"
                    value={filteringView}
                    exclusive
                    onChange={(event, newView) => newView && setFilteringView(newView)}
                    aria-label="filtering toggle"
                    sx={{
                      p: 0.25,
                      '& .MuiToggleButton-root': {
                        px: 1,
                        py: 0.25,
                        fontSize: '12px',
                        lineHeight: 1.2,
                        minHeight: '28px'
                      }
                    }}
                  >
                    <ToggleButton value="pre" aria-label="pre-filtering">
                      Pre-filtering
                    </ToggleButton>
                    <ToggleButton value="post" aria-label="post-filtering">
                      Post-filtering
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              ) : null}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <p>
                    <b>Q20 Rate:</b>
                    {' '}
                    {formatPercent(metrics.q20)}%
                  </p>
                  <p style={{ marginBottom: 0 }}>
                    <b>GC Content:</b>
                    {' '}
                    {formatPercent(metrics.gc)}%
                  </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <p style={{ marginBottom: 0 }}>
                    <b>Q30 Rate:</b>
                    {' '}
                    {formatPercent(metrics.q30)}%
                  </p>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ borderTop: '1px solid #e0e0e0', pt: 2 }}>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <p>
                    <b>Adapter Content:</b>
                    {' '}
                    {formatPercent(analysis?.attributes?.adapter_rate)}%
                  </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <p>
                    <b>Duplication Rate:</b>
                    {' '}
                    {formatPercent(analysis?.attributes?.duplication_rate)}%
                  </p>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ borderTop: '1px solid #e0e0e0', mt: 1, pt: 2 }}>
              <Grid container>
                <Grid item xs={12} sm={6}>
            <p>
              <b>Average Read Length:</b>
              {' '}
              {formatReadLength(
                analysis?.attributes?.human_reads_removed_megabases,
                analysis?.attributes?.human_reads_removed_reads
              )} bases
            </p>
                </Grid>
                <Grid item xs={12} sm={6}>
            <p>
              <b>Max Read Length:</b>
              {' '}
              {hasValue(analysis?.attributes?.human_reads_removed_max_read_length)
                ? analysis.attributes.human_reads_removed_max_read_length.toLocaleString()
                : '-'} bases
            </p>
                </Grid>
              </Grid>
            </Box>
      </Box>
      </Grid>
      </Grid>
    </>
  );
}

export default DetailedSequencingQualitySummary;
